import React, { useEffect, useRef } from 'react'
import i18n from "../../public/texts.json"
import Menu from './menu'
import Welcome from './welcome'
import Footer from './footer'
import BlockSection from './block-section'
import Picture from './picture'
import Grid from './grid'
import PictureContainer from './picture-container'
import ExploreSection from './explore-section'
import constants from '../constants'
import MenuMobile from './menu-mobile'
import Actions from '../actions'
import {gsap} from 'gsap'
import { SplitText } from "gsap/SplitText.js"

gsap.registerPlugin(SplitText)

const App = () => {
  const texts = i18n.filter(item => item.id === LANG_ID)[0].texts
  const listWrapperEl = useRef()
  const listEl = useRef()
  const appTemplateEl = useRef()
  const dates = useRef()
  const sections = useRef()
  const allParagraphs = useRef()
  const changeAnchorTimeout = useRef()
  useEffect(() => {
    const onIntersect = (entries) => {
      entries.forEach(entry => {
        const target = entry.target
        if (entry.isIntersecting) {
          if (target.classList.contains(`block-date`)) {
            const dateId = target.getAttribute(`data-id`)
            const currentDate = dates.current.filter(item => item.id === dateId)[0]
            currentDate.tl.play(0)
          }
          if (target.classList.contains(`section-title-h2`)) {
            const sectionId = target.getAttribute(`data-id`)
            const currentSection = sections.current.filter(item => item.id === sectionId)[0]
            currentSection.tl.play(0)
          }
          if (target.classList.contains(`p-title`)) {
            const paragraphId = target.getAttribute(`data-id`)
            const currentParagraph = allParagraphs.current.filter(item => item.id === paragraphId)[0]
            currentParagraph.tl.play(0)
          }
        }
      })
    }
    const observer = new IntersectionObserver(onIntersect, {
      rootMargin: `150px 0px 150px 0px`,
      threshold: 0
    })
    const blockDates = [...listWrapperEl.current.getElementsByClassName(`block-date`)]
    const sectionTitles = [...listWrapperEl.current.getElementsByClassName(`section-title-h2`)]
    const paragraphs = [...listWrapperEl.current.getElementsByClassName(`section-paragraph`)]
    dates.current = blockDates.map((item, index) => {
      const id = `date-${index}`
      const tl = gsap.timeline()
      item.setAttribute(`data-id`, id)
      const split = new SplitText(item, {type: "chars", position: "relative" })
      tl.from(split.chars, {duration: 1, y: window.isMobile ? 200 : 400, autoAlpha: 0, stagger: 0.1, ease: `expo.out`}).pause(0)
      return {
        id,
        tl
      }
    })
    sections.current = sectionTitles.map((item, index) => {
      const id = `section-title-${index}`
      const tl = gsap.timeline()
      item.setAttribute(`data-id`, id)
      const children = item.childNodes
      const split = new SplitText(children[1], {type: "chars,words", position: "relative" })
      tl.from(children[0], {duration: 0.8, y: window.isMobile ? 20 : 40, autoAlpha: 0, ease: `expo.out` }, 0.2)
      tl.from(split.chars, {duration: 0.8, y: window.isMobile ? 20 : 40, autoAlpha: 0, stagger: 0.05, ease: `expo.out`}, 0.4)
      tl.pause(0)
      return {
        id,
        tl
      }
    })
    allParagraphs.current = paragraphs.map((item, index) => {
      const id = `p-title-${index}`
      const tl = gsap.timeline()
      item.setAttribute(`data-id`, id)
      item.classList.add(`p-title`)
      const split = new SplitText(item, {type: "lines,words", linesClass: "tw-whitespace-nowrap" })
      tl.from(split.lines, {duration: 0.8, y: window.isMobile ? 20 : 40, autoAlpha: 0, stagger: 0.1, ease: `expo.out`}, 0.4)
      tl.pause(0)
      return {
        id,
        tl
      }
    })
    // Paragraphs and Date svgs and H2 texts
    const allBlocks = [
      ...blockDates,
      ...sectionTitles,
      ...paragraphs,
    ]
    allBlocks.forEach(item => observer.observe(item))
    return () => {
      observer.disconnect()
    }
  }, [])
  useEffect(() => {
    const onIntersect = (entries) => {
      entries.forEach(entry => {
        const target = entry.target
        if (entry.isIntersecting) {
          if (target.classList.contains(`block-section`)) {
            clearTimeout(changeAnchorTimeout.current)
            changeAnchorTimeout.current = setTimeout(Actions.changeAnchor, 400, target.getAttribute(`data-anchor`))
          }
        }
      })
    }
    const observer = new IntersectionObserver(onIntersect, {
      rootMargin: `0px 0px 0px 0px`,
      threshold: 0.35
    })
    const allBlocks = [
      ...listWrapperEl.current.getElementsByClassName(`block-section`)
    ]
    allBlocks.forEach(item => observer.observe(item))
    return () => {
      observer.disconnect()
    }
  }, [])
  const sectionsItems = [

    <Welcome titleContent={texts[0].title} />,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0`}
      anchorName={`1847`}
      date={1847}
      backgroundClassName={`tw-bg-gray-light tw-h-full md:tw-h-10/12`}
      titleClassName={`tw-mt-14 tw-mb-5 md:tw-mt-28 md:tw-mb-10 lg:tw-mt-48 lg:tw-mb-16`}
      subtitleContent={texts[1].subtitle}
      titleContent={texts[1].title}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-my-5 md:tw-pr-5 md:tw-col-end-7 md:tw-mt-10 lg:tw-pr-0 lg:tw-mt-24 lg:tw-col-start-4 lg:tw-col-end-6`}>{texts[1].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-mb-10 md:tw-col-start-7 md:tw-col-end-12 xl:tw-col-end-11`}>
        <Picture
          className={`tw-relative md:tw--top-12 lg:tw--top-20 2xl:tw--top-24`}
          filename={`B112_11LF-Cartier_165129-copie`}
          alt={texts[1][`menu-title`]}
          animation={`mask-left`}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0`}
      anchorName={`1856`}
      date={1856}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-my-5 md:tw-pr-5 md:tw-col-end-7 lg:tw-pr-0 lg:tw-col-start-4 lg:tw-col-end-6 md:tw-mt-10 lg:tw-mt-24`}>{texts[2].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-mb-10 md:tw-col-start-7 md:tw-col-end-12 lg:tw-col-end-11`}>
        <Picture
          className={`tw-relative md:tw--top-20 xl:tw--top-24 2xl:tw--top-32 `}
          filename={`B262_Princesse-Mathilde_165539_BD-1920`}
          alt={texts[2][`menu-title`]}
          animation={`mask-left`}
          duration={1.4}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0`}
      anchorName={`1898`}
      date={1898}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-row-start-2 md:tw-row-start-1 md:tw-col-start-2 md:tw-col-end-8 xl:tw-col-start-4 xl:tw-col-end-9`}>
        <Picture
          className={`tw-relative md:tw--top-20 lg:tw--top-28 2xl:tw--top-36`}
          filename={`B838_Louis_Cartier_Friand_170603copie`}
          alt={texts[3][`menu-title`]}
          animation={`translate-y`}
          translate={120}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-row-start-1 tw-my-5 md:tw-col-start-9 md:tw-col-end-12 xl:tw-col-end-11 md:tw-mt-10 lg:tw-mt-24`}>{texts[3].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 xl:tw-mb-0`}
      anchorName={`1899`}
      date={1899}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`tw-col-start-2 tw-col-end-13 tw-mb-5 md:tw-mb-0 xl:tw-col-start-4 tw-relative`}>
        <ExploreSection anchorName={`1899`} top={20} scaleX={18} scaleY={12}>
          <PictureContainer className={`tw-relative`}>
            <Picture explore={true} className={`tw-relative md:tw--top-10 xl:tw--top-14`} filename={`C1212B_Voiture-rue-de-la-Paix_1664668`} alt={texts[4][`menu-title`]} />
          </PictureContainer>
        </ExploreSection>
      </div>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-end-7 xl:tw-col-start-4 lg:tw-col-end-6`}>{texts[4].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-7 md:tw-col-end-12 xl:tw-col-start-6 xl:tw-col-end-11`}>
        <Picture
          className={`tw-relative md:tw--top-10 xl:tw--top-14`}
          filename={`DiademNH_1326553_1977`}
          alt={texts[4][`menu-title`]}
          animation={`translate-y`}
          translate={120}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0 tw-relative tw-z-10`}
      anchorName={`1902`}
      date={1902}
      svgWrapperClassName={`tw-relative tw-z-20 tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-row-start-2 md:tw-row-start-1 xl:tw-col-start-4 md:tw-col-end-8`}>
        <Picture
          className={`tw-relative md:tw--top-14 xl:tw--top-20`}
          filename={`B859_PIERRE_C-RETOUCHE_170815`}
          alt={texts[5][`menu-title`]}
          animation={`mask-right`}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-row-start-1 tw-mb-5 md:tw-mb-0 md:tw-col-start-9 xl:tw-col-end-11 md:tw-mt-10 xl:tw-mt-24`}>{texts[5].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-12 md:tw--mt-24 lg:tw--mt-40 tw-bg-gray-light md:tw-bg-white tw-pb-10 md:tw-pb-0`}
      anchorName={`1900`}
      date={1900}
      backgroundClassName={`tw-bg-gray-light tw-h-full`}
      titleClassName={`tw-mt-5 tw-mb-5 md:tw-mt-24 md:tw-mb-10 lg:tw-mt-48 lg:tw-mb-16`}
      subtitleContent={texts[6].subtitle}
      titleContent={texts[6].title}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
      isAnnées={true}
      annéesClassName={`tw-relative tw-z-20 tw--top-7 sm:tw--top-12 md:tw--top-16 xl:tw--top-20 2xl:tw--top-28 tw-pr-6`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 md:tw-mt-0 xl:tw-mt-10 md:tw-pb-16`}>{texts[6].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 md:tw-col-end-12`}>
        <Picture
          filename={`CL193A13_fb_VW_1532720-1`}
          className={`tw-w-full lg:tw--mt-16`}
          animation={`translate-y`}
          alt={texts[6][`menu-title`]}
          translate={120}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0`}
      anchorName={`1904`}
      date={1904}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-row-start-2 md:tw-row-start-1 md:tw-col-start-4 md:tw-col-end-8`}>
        <Picture
          className={`tw-relative 2xl:tw--top-44 lg:tw--top-36 md:tw--top-24 md:tw--left-10`}
          filename={`B991_B748_8_BREVET_ANGL_EDOUARDVII_178825_BD-1920`}
          alt={texts[7][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-mt-5 md:tw-col-start-9 md:tw-col-end-12 xl:tw-col-end-11 md:tw-mt-10 lg:tw-mt-24`}>{texts[7].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0`}
      anchorName={`1904-2`}
      date={1904}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-z-20 tw-col-start-2 tw-col-end-12 md:tw-col-end-7 xl:tw-col-start-4 xl:tw-col-end-6 md:tw-mt-10 md:tw-mb-12 xl:tw-mt-20 xl:tw-mb-24`}>{texts[8].paragraph}</div>
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 md:tw-absolute md:w-4/12 md:tw-left-1/2 lg:w-3/12`}>
        <Picture
          className={`tw-relative tw-w-full 2xl:tw--left-8 md:tw--left-4 2xl:tw--top-40 lg:tw--top-36 md:tw--top-24`}
          filename={`WCL140A12_fb_VW_1568293_BD-1920`}
          alt={texts[8][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <Grid className={`tw-col-start-1 tw-col-end-13 tw-gap-y-5 md:tw-gap-y-8`}>
        <PictureContainer className={`tw-col-start-2 tw-col-end-12 lg:tw-col-start-4 md:tw-col-end-7 tw-relative tw-z-10 md:tw-pr-5`}>
          <Picture
            className={`tw-pb-5 md:tw-pb-10`}
            filename={`PRSO_SANTOS-DUMONT_ALB_P04_1_1758572`}
            animation={`mask-right`}
            alt={texts[8][`menu-title`]}
            duration={1}
          />
          <Picture
            filename={`PRSO_SANTOS-DUMONT_ALB_P15_1_1758600`}
            animation={`mask-right`}
            alt={texts[8][`menu-title`]}
            duration={1.4}
          />
        </PictureContainer>
        <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-7 lg:tw-col-end-11 tw-relative tw-z-10`}>
          <div className={`tw-flex tw-flex-col tw-justify-end tw-h-full`}>
            <Picture
              className={`md:tw-pl-5`}
              filename={`PRSO_SANTOS-DUMONT_ALB_P05_1_1758575`}
              animation={`mask-left`}
              alt={texts[8][`menu-title`]}
              duration={1.4}
            />
          </div>
        </PictureContainer>
        <PictureContainer className={`tw-col-start-2 lg:tw-col-start-4 tw-col-end-13 tw-relative`}>
          <ExploreSection anchorName={`1904-2`} top={20} scaleX={14} scaleY={12}>
            <Picture explore={true} className={``} filename={`A32_25_PIE_1_07_164895_BD-1920`} alt={texts[8][`menu-title`]} />
          </ExploreSection>
        </PictureContainer>
      </Grid>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`1909`}
      date={1909}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 xl:tw-col-end-11 tw-relative md:tw--top-14 lg:tw--top-20`}>
        <ExploreSection anchorName={`1909`} top={36} scaleX={16} scaleY={12}>
          <Picture explore={true} className={`tw-relative`} filename={`A32_18_AVE_6_04_164893`} alt={texts[9][`menu-title`]} />
        </ExploreSection>
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-11 xl:tw-col-start-5 xl:tw-col-end-9 tw-relative tw-mt-5 md:tw--mt-6 md:tw-mb-20 lg:tw-mb-32`}>{texts[9].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0`}
      anchorName={`1911`}
      date={1911}
      svgWrapperClassName={`tw-relative tw-z-10 w-11/12 tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-mb-5 xl:tw-col-start-4 md:tw-col-end-7 md:tw-mt-14 md:tw-mb-8 lg:tw-mt-20 lg:tw-mb-12`}>{texts[10].paragraph}</div>
      <Grid className={`tw-col-start-1 tw-col-end-13`}>
        <PictureContainer className={`tw-col-start-3 tw-col-end-12 md:tw-col-end-7 tw-mb-5 md:tw-mb-0`}>
          <div className={`tw-w-full flex flex-row-reverse`}>
            <div className={`md:w-76% tw-mb-5 lg:tw-mb-10`}>
              <Picture
                filename={`ICONO-80X60-A96_03Jacques-CARTIER-AU-BAHRAIN_165038-ter_2012283_2047176`}
                alt={texts[10][`menu-title`]}
                animation={`mask-right`}
                duration={1}
              />
            </div>
          </div>
          <Picture
            filename={`ICONO-80X60-B958_J_CARTIER_VOYAGE1_17_2_V3_175734-ter_2012286`}
            alt={texts[10][`menu-title`]}
            animation={`mask-right`}
            duration={1.4}
          />
        </PictureContainer>
        <PictureContainer className={`tw-col-start-2 md:tw-col-start-7 tw-col-end-12 md:tw-pl-5 lg:tw-pl-10 tw-space-y-5 lg:tw-space-y-10 md:tw--mt-64 lg:tw--mt-72 2xl:tw--mt-96`}>
          <div className={`tw-relative`}>
            <ExploreSection anchorName={`1911`} top={32} scaleX={14} scaleY={10}>
              <Picture
                explore={true}
                filename={`ICONO-80X60-A96_01Jacques-CARTIER-AU-BAHRAIN_165036-ter_2012282`}
                alt={texts[10][`menu-title`]}
                animation={`mask-left`}
                duration={1}
              />
            </ExploreSection>
          </div>
          <Picture
            filename={`ICONO-80X60-A96_04Jacques-CARTIER-AU-BAHRAIN_165039-ter_2012284`}
            alt={texts[10][`menu-title`]}
            animation={`mask-left`}
            duration={1.4}
          />
          <Picture
            className={`md:w-76%`}
            filename={`ICONO-80X60-B961_J_CARTIER_VOYAGE2_22_1_R4_176024-ter_2012288`}
            alt={texts[10][`menu-title`]}
            animation={`mask-left`}
            duration={1.3}
          />
        </PictureContainer>
      </Grid>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`1912`}
      date={1912}
      svgWrapperClassName={`tw-relative tw-z-20 w-11/12 tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 md:tw-col-end-10`}>
        <Picture
          className={`tw-relative md:tw--top-24 xl:tw--top-44 md:tw-ml-10`}
          filename={`CM19A14_f-NH_1855177-copie-1`}
          alt={texts[11][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 tw-mb-5 md:tw-mb-0 md:tw-mt-10 lg:tw-mt-24`}>{texts[11].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0`}
      anchorName={`1914`}
      date={1914}
      svgWrapperClassName={`tw-relative tw-z-20 w-11/12 tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 tw-row-start-2 md:tw-row-start-1 md:tw-col-start-4 md:tw-col-end-8 2xl:tw--mt-44 lg:tw--mt-32 md:tw--mt-24`}>
        <Picture
          className={`tw-relative md:right-8 xl:right-5 md:tw-pl-5 xl:tw-pl-20`}
          filename={`WWL98A14_f-NH_1519628-copie-1`}
          alt={texts[12][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 2xl:tw-col-start-9 md:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-28 tw-mb-5 md:tw-mb-0`}>{texts[12].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0`}
      anchorName={`1917`}
      date={1917}
      svgWrapperClassName={`tw-relative tw-z-20 w-11/12 tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 tw-row-start-2 md:tw-row-start-1 md:tw-col-start-6 md:tw-col-end-10`}>
        <Picture
          className={`2xl:tw--mt-40 md:tw--mt-32 xl:tw--mt-44 md:tw-ml-10 tw-relative md:right-4`}
          filename={`WCL115A20_fb_VW_1568287-copie-2`}
          alt={texts[13][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[13].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1924`}
      date={1924}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-row-start-2 md:tw-row-start-1 xl:tw-col-start-4 md:tw-col-end-8`}>
        <Picture
          className={`md:tw--mt-12`}
          filename={`B4052700_255206-copie-2`}
          alt={texts[14][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-start-9 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[14].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1925`}
      date={1925}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 md:tw-col-start-6 tw-col-end-12 md:tw-mt-8`}>
        <Picture
          className={`tw-relative md:tw-left-4 xl:tw-left-0 md:tw--mt-10 xl:tw-pr-20`}
          filename={`BT111A29_ou-NH_1326539-3`}
          alt={texts[15][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[15].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`1925-2`}
      date={1925}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 md:tw-col-start-6 tw-col-end-12 tw-relative`}>
        <Picture className={`2xl:tw--mt-28 lg:tw--mt-24 md:tw--mt-16 md:tw-pl-10 xl:tw-pr-20`} filename={`C1212B_Voiture-rue-de-la-Paix_1664668-(1)`} alt={texts[16][`menu-title`]} />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-44 tw-mb-5 md:tw-mb-0`}>{texts[16].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-28 tw-relative tw-z-10`}
      anchorName={`1928`}
      date={1928}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-8 tw-relative`}>
        <Picture
          className={`md:tw--mt-20 lg:tw--mt-36 md:tw--ml-4`}
          filename={`NE40A28_d-NH_1704108_BD-1920-2`}
          alt={texts[17][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 tw-row-start-1 md:tw-col-start-8 xl:tw-col-start-9 md:tw-col-end-11 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[17].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-bg-gray-light tw-pb-10 md:tw-pb-20 xl:tw-pb-40 tw-mb-10 md:tw-mb-0 md:tw--mt-14 lg:tw--mt-20 2xl:tw--mt-24`}
      anchorName={`1933`}
      date={1933}
      titleClassName={`tw-mt-10 tw-mb-5 md:tw-mt-20 md:tw-mb-8 lg:tw-mt-48 lg:tw-mb-16`}
      subtitleContent={texts[18].subtitle}
      titleContent={texts[18].title}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6`}>
        <div className={`${constants.paragraph} section-paragraph 2xl:tw-mt-60 xl:tw-mt-52 md:tw-mt-10 tw-mb-5 xl:tw-mb-20`}>{texts[18].paragraph}</div>
        <PictureContainer className={`tw-mb-5 md:tw-mb-0`}>
          <Picture
            className={``}
            filename={`B121_20jeanne-toussaint_165163_BD-1920`}
            alt={texts[18][`menu-title`]}
            animation={`mask-right`}
            duration={1}
          />
        </PictureContainer>
      </div>
      <div className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 xl:tw-col-end-11`}>
        <PictureContainer className={`tw-relative md:tw-pl-5 xl:tw-pl-12 md:tw--top-16 lg:tw--top-16`}>
          <ExploreSection anchorName={`1933`} top={`0`} scaleX={16} scaleY={18}>
            <Picture explore={true} className={``} filename={`B837_JeanneToussaintHelleu_170590_1977326_BD-1920`} alt={texts[18][`menu-title`]} />
          </ExploreSection>
        </PictureContainer>
      </div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`1942`}
      date={1942}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-32`}>{texts[19].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 md:tw-col-end-10 2xl:tw--mt-40 xl:tw--mt-28 lg:tw--mt-20 md:tw--mt-16`}>
        <Picture
          className={`md:tw--mt-10 md:tw-pl-5 xl:tw-pl-10 xl:tw-pr-10`}
          filename={`CL77A44_fb_VW_1532702-1`}
          alt={texts[19][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1948`}
      date={1948}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-8`}>
        <Picture
          className={`md:tw-pr-10 xl:tw-pr-20 2xl:tw--mt-40 lg:tw--mt-28 md:tw--mt-20`}
          filename={`C1034_AMAZING_06-PANTHERE_WINDSOR_181524-2`}
          alt={texts[20][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-9 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-20 tw-relative md:right-10 xl:right-20`}>{texts[20].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1967`}
      date={1967}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[21].paragraph}</div>
      <PictureContainer className={`tw-col-start-4 md:tw-col-start-7 tw-col-end-11`}>
        <Picture
          className={`tw-relative 2xl:right-20 xl:right-14 md:right-8 md:tw-pr-0 xl:tw-pr-20 2xl:tw--mt-44 xl:tw--mt-36 md:tw--mt-20`}
          filename={`WCL53A67_fb_VW_1568203-1`}
          alt={texts[21][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16 tw-relative tw-z-10`}
      anchorName={`1968`}
      date={1968}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-8 md:tw--mt-16 lg:tw--mt-20 xl:tw--mt-24`}>
        <Picture
          className={`2xl:tw--mt-10 md:tw--mt-0 lg:tw-pr-5 xl:tw-pr-10`}
          filename={`NE10A68_v6_VW_fb_1633349_BD-1920-1`}
          alt={texts[22][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 md:tw-col-end-11 xl:tw-col-end-10 tw-row-start-1 md:tw-mt-10 xl:tw-mt-16 2xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[22].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-bg-gray-light tw-pb-10 md:tw-pb-20 xl:tw-pb-32 tw-mb-10 md:tw-mb-0 md:tw--mt-8 xl:tw--mt-16`}
      anchorName={`1969`}
      date={1969}
      titleClassName={`tw-mt-10 tw-mb-5 md:tw-mt-20 md:tw-mb-16 xl:tw-mt-52 xl:tw-mb-24`}
      subtitleContent={texts[23].subtitle}
      titleContent={texts[23].title}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[23].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 md:tw-col-start-6 tw-col-end-12 2xl:tw--mt-40 xl:tw--mt-32 lg:tw--mt-24 md:tw--mt-20`}>
        <Picture
          className={`xl:tw-pr-20`}
          filename={`BT153A69-NH_1704044_BD-1920`}
          alt={texts[23][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`1971`}
      date={1971}
      svgWrapperClassName={`tw-relative tw-z-20 w-11/12 tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 tw-row-start-2 md:tw-row-start-1 xl:tw-col-start-4 md:tw-col-end-9 md:tw--mt-16 lg:tw--mt-24 xl:tw--mt-32`}>
        <Picture
          className={`2xl:tw--mt-16 md:tw--mt-7 tw-relative 2xl:right-6 md:right-2 md:tw-pr-5 lg:tw-pr-10 xl:tw-pr-20`}
          filename={`BT119A71-NH_1326628-2`}
          alt={texts[24][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-relative md:tw-left-4 xl:tw-left-0 tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-start-9 md:tw-col-end-11 tw-row-start-1 md:tw-mt-10 lg:tw-mt-20 xl:tw-mt-32 tw-mb-5 md:tw-mb-0 tw-z-20`}>{texts[24].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0`}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-5`}
      anchorName={`1973`}
      date={1973}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-6 md:tw-mt-10 xl:tw-mt-20 tw-mb-5 md:tw-mb-20 xl:tw-mb-24`}>{texts[25].paragraph}</div>
      <Grid className={`tw-col-start-1 tw-col-end-13`}>
        <PictureContainer className={`tw-col-start-3 tw-col-end-12 md:tw-col-end-7 tw-relative tw-z-10 md:tw-mr-5`}>
          <div className={`tw-h-full tw-flex tw-flex-col tw-items-end`}>
            <div className={`tw-w-full md:tw-w-76% tw-mb-5 lg:tw-mb-10`}>
              <Picture
                filename={`B528_maroquinerie-129i5logo_166636`}
                alt={texts[25][`menu-title`]}
                animation={`mask-right`}
                duration={1}
              />
            </div>
            <div className={`tw-w-full tw-pb-5 xl:tw-pb-10`}>
              <Picture
                filename={`PUB_G_1980_02_01_908058`}
                alt={texts[25][`menu-title`]}
                animation={`mask-right`}
                duration={1.4}
              />
            </div>
            <div className={`tw-w-full md:w-76% tw-mb-5 lg:tw-mb-10`}>
              <Picture
                filename={`STORE_1974_166176`}
                alt={texts[25][`menu-title`]}
                animation={`mask-right`}
                duration={1.3}
              />
            </div>
          </div>
        </PictureContainer>
        <PictureContainer className={`tw-col-start-2 md:tw-col-start-7 tw-col-end-12 tw-relative tw-z-10 md:tw--mt-64 xl:tw--mt-80 md:tw-pr-5 lg:tw-pr-10 xl:tw-pr-20`}>
          <Picture
            className={`xl:tw-pl-5 tw-pb-5 xl:tw-pb-10`}
            filename={`B528_maroquinerie-128i4_166635`}
            alt={texts[25][`menu-title`]}
            animation={`mask-left`}
            duration={1}
          />
          <Picture
            className={`xl:tw-pl-5 tw-pb-5 xl:tw-pb-10`}
            filename={`PRODS_ACCESSOIRES_MUST_1976_166624`}
            alt={texts[25][`menu-title`]}
            animation={`mask-left`}
            duration={1.4}
          />
          <Picture
            className={`xl:tw-pl-5 tw-pb-5 md:tw-pb-0`}
            filename={`B528_maroquinerie-140i2_166640`}
            alt={texts[25][`menu-title`]}
            animation={`mask-left`}
            duration={1.3}
          />
        </PictureContainer>
      </Grid>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1977`}
      date={1977}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 md:tw-col-start-7 md:tw-col-end-10`}>
        <Picture
          className={`2xl:tw--mt-64 xl:tw--mt-52 lg:tw--mt-40 md:tw--mt-32 md:tw-ml-24 xl:tw-ml-28 tw-relative lg:right-0 md:right-4`}
          filename={`ST-WCL245A77_fn_VW_1568315-1`}
          alt={texts[26][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-7 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[26].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1978`}
      date={1978}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 md:tw-col-start-5 md:tw-col-end-8`}>
        <Picture
          className={`tw-relative 2xl:tw--mt-44 xl:tw--mt-36 md:tw--mt-24 md:-right-5 xl:-right-20`}
          filename={`ST-WCL253A81_fb_VW_2027272-1`}
          alt={texts[27][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-9 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0 tw-z-20`}>{texts[27].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16 tw-bg-gray-light md:tw-bg-white tw-pb-10 md:tw-pb-0`}
      backgroundClassName={`tw-bg-gray-light tw-h-full md:tw-h-11/12 tw-pb-10`}
      anchorName={`1983`}
      date={1983}
      titleClassName={`tw-mt-10 tw-mb-5 md:tw-mt-20 md:tw-mb-10 xl:tw-mt-40 xl:tw-mb-16`}
      subtitleContent={texts[28].subtitle}
      titleContent={texts[28].title}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-5 tw-col-end-10 md:tw-col-start-4 md:tw-col-end-6`}>
        <Picture
          className={`tw-relative 2xl:tw--mt-52 xl:tw--mt-32 lg:tw--mt-36 md:tw--mt-24 xl:tw--right-20 2xl:tw--right-24`}
          filename={`WGPN0008_crop_fn_1438033-3`}
          alt={texts[28][`menu-title`]}
          animation={`translate-y`}
          translate={140}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 md:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[28].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-10 xl:tw-mt-20`}
      anchorName={`1983-2`}
      date={1983}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-relative tw-col-start-2 xl:tw-col-start-4 tw-col-end-13 tw-mb-5 md:tw-mb-0`}>
        <Picture
          className={`2xl:tw--mt-16 md:tw--mt-10`}
          filename={`Collection-Cartier-Chine-NH2016_1465936_BD-1920`}
          alt={texts[29][`menu-title`]}
          animation={`mask-left`}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-10 md:tw-mt-10 md:tw-mb-10 xl:tw-mb-20`}>{texts[29].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-10 xl:tw-mt-20`}
      anchorName={`1984`}
      date={1984}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-relative tw-col-start-2 xl:tw-col-start-4 tw-col-end-13 tw-mb-5 md:tw-mb-0`}>
        <Picture className={`2xl:tw--mt-16 md:tw--mt-10`} filename={`C1212B_Voiture-rue-de-la-Paix_1664668__2`} alt={texts[30][`menu-title`]} />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-9 xl:tw-col-end-8 md:tw-mt-10 md:tw-mb-10 xl:tw-mb-20`}>{texts[30].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-5 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1985`}
      date={1985}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 md:tw-col-start-7 md:tw-col-end-10`}>
        <Picture
          className={`2xl:tw--mt-52 xl:tw--mt-36 lg:tw--mt-32 md:tw--mt-24 tw-relative md:tw-left-4 xl:tw-left-0`}
          filename={`ST-WCL172_'1985-replica'_cuir_SG_2039601-copie-2`}
          alt={texts[31][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[31].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1989`}
      date={1989}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-8 md:tw-pr-12 xl:tw-pr-28`}>
        <Picture
          className={`2xl:tw--mt-24 md:tw--mt-16`}
          filename={`B808_ExpoArtdeCartier_PtPalais_170237-2`}
          alt={texts[32][`menu-title`]}
          animation={`mask-right`}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 md:tw-col-end-11 xl:tw-col-end-10 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[32].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`1996`}
      date={1996}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-4 tw-col-end-11 md:tw-col-start-7 md:tw-col-end-10`}>
        <Picture
          className={`2xl:tw--mt-48 xl:tw--mt-36 lg:tw--mt-28 md:tw--mt-24 tw-relative md:tw-left-4 xl:tw-left-0`}
          filename={`ST-WCL172_'1985-replica'_cuir_SG_2039601-copie-2-(1)`}
          alt={texts[33][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[33].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-16`}
      anchorName={`1997`}
      date={1997}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-8 xl:tw-pl-16 2xl:tw-pl-24 md:tw-pr-10 xl:tw-pr-14 2xl:tw-pr-28`}>
        <Picture
          className={`2xl:tw--mt-24 lg:tw--mt-16 md:tw--mt-12`}
          filename={`B808_ExpoArtdeCartier_PtPalais_170237-2-(1)`}
          alt={texts[34][`menu-title`]}
          animation={`mask-right`}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[34].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20 tw-relative tw-z-10`}
      anchorName={`1999`}
      date={1999}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[35].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-7 md:tw-col-end-11`}>
        <Picture
          className={`2xl:tw--mt-48 xl:tw--mt-36 md:tw--mt-24 tw-relative md:tw-left-6 xl:tw-left-0`}
          filename={`ST-NE17A99_SG_1752186-1`}
          alt={texts[35][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-pb-10 md:tw-pb-0 md:tw--mt-16 xl:tw--mt-40 md:tw-mb-24 tw-bg-gray-light md:tw-bg-white`}
      anchorName={`2000`}
      date={2000}
      backgroundClassName={`tw-bg-gray-light tw-h-full`}
      titleClassName={`tw-mt-10 tw-mb-5 md:tw-mt-20 md:tw-mb-10 xl:tw-mt-64 xl:tw-mb-16`}
      subtitleContent={texts[36].subtitle}
      titleContent={texts[36].title}
      svgWrapperClassName={`tw-relative tw-z-10 tw-w-full`}
      isAnnées={true}
      annéesClassName={`tw-relative tw-z-20 tw--top-12 md:tw--top-14 lg:tw--top-16 xl:tw--top-20 2xl:tw--top-24 w-1/4 tw--left-4 md:tw--left-7 tw-pr-10`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 md:tw-mt-5 xl:tw-mt-20 md:tw-pb-16 tw-mb-5 md:tw-mb-0`}>{texts[36].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 xl:tw-col-end-11 md:tw-pl-5 xl:tw-pl-10 xl:tw-pr-10`}>
        <Picture
          className={``}
          filename={`H6007717-AUZ336_Saphir-d_NH_crop_1003123-1`}
          alt={texts[36][`menu-title`]}
          animation={`translate-y`}
          translate={120}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 tw-mt-10 md:tw-mt-20`}
      anchorName={`2001`}
      date={2001}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-relative tw-col-start-3 tw-col-end-13 2xl:tw-pl-32 xl:tw-pl-20 tw-mb-5 md:tw-mb-0`}>
        <Picture className={`2xl:tw--mt-20 xl:tw--mt-16 md:tw--mt-10`} filename={`MANUF-EXT-RECADRAGE-3-1`} alt={texts[37][`menu-title`]} />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-9 md:tw-mt-10 xl:tw-mt-16 xl:tw-mb-24`}>{texts[37].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2003`}
      date={2003}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 md:tw--ml-12 md:tw-pr-5 xl:tw-pr-16 tw-mb-5 md:tw-mb-0`}>{texts[38].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 xl:tw-col-end-11 md:tw-pr-10`}>
        <Picture
          className={`tw-relative 2xl:right-10 xl:right-4 md:tw-left-2 xl:tw-left-0 2xl:tw--mt-16 md:tw--mt-10`}
          filename={`32_image_damimage_standard_1417683333058-1`}
          alt={texts[38][`menu-title`]}
          animation={`mask-left`}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2005`}
      date={2005}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-8 2xl:tw-pl-24 xl:tw-pl-14 md:tw-pr-12 lg:tw-pr-16 2xl:tw-pr-36`}>
        <Picture
          className={`2xl:tw--mt-20 lg:tw--mt-14 md:tw--mt-10 tw-relative md:right-4 xl:right-0`}
          filename={`00_59_B_new-1`}
          alt={texts[39][`menu-title`]}
          animation={`mask-right`}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-end-11 tw-row-start-1 2xl:tw-mt-40 md:tw-mt-10 xl:tw-mt-32 tw-mb-5 md:tw-mb-0`}>{texts[39].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2006`}
      date={2006}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 md:tw--ml-12 md:tw-pr-5 xl:tw-pr-16 tw-mb-5 md:tw-mb-0`}>{texts[40].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 xl:tw-col-end-11 md:tw-pr-10`}>
        <Picture
          className={`tw-relative 2xl:right-10 xl:right-4 md:tw-left-2 xl:tw-left-0 2xl:tw--mt-16 md:tw--mt-10`}
          filename={`DSC04754-our-vision-1`}
          alt={texts[40][`menu-title`]}
          animation={`mask-left`}
          duration={1.1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`2007`}
      date={2007}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-5 tw-col-end-10 md:tw-col-start-4 md:tw-col-end-7 xl:tw-col-start-5 xl:tw-col-end-8 2xl:tw-pr-36 xl:tw-pr-16`}>
        <Picture
          className={`2xl:tw--mt-40 xl:tw--mt-28 lg:tw--mt-32 md:tw--mt-24 tw-relative xl:right-6`}
          filename={`WE9006Z3_fn_RVB_maj_639809-2`}
          alt={texts[41][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-36 tw-mb-5 md:tw-mb-0`}>{texts[41].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`2007-2`}
      date={2007}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 md:tw--ml-12 md:tw-pr-5 xl:tw-pr-16 tw-mb-5 md:tw-mb-0`}>{texts[42].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-6 xl:tw-col-end-11 md:tw-pr-10`}>
        <Picture
          className={`tw-relative 2xl:right-10 xl:right-4 md:tw-left-2 xl:tw-left-0 2xl:tw--mt-16 md:tw--mt-10`}
          filename={`Horizontale780cmx1280cm_080307-1`}
          alt={texts[42][`menu-title`]}
          animation={`mask-left`}
          duration={1.1}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20 xl:tw-mt-36`}
      anchorName={`2010`}
      date={2010}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-5 tw-col-end-10 md:tw-col-start-5 md:tw-col-end-7`}>
        <Picture
          className={`tw-relative md:tw-left-10 2xl:tw--mt-96 xl:tw--mt-72 lg:tw--mt-60 md:tw--mt-52`}
          filename={`HP302954-SX1832_RVB_592428-1`}
          alt={texts[43][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-36 tw-mb-5 md:tw-mb-0`}>{texts[43].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2012`}
      date={2012}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-relative tw-col-start-2 xl:tw-col-start-4 tw-col-end-13 tw-mb-5 md:tw-mb-0`}>
        <ExploreSection anchorName={`2012`} top={`16`} scaleX={18} scaleY={14}>
          <Picture explore={true} className={`2xl:tw--mt-20 md:tw--mt-14`} filename={`Boma-Project-Kenya-BOMA-Project-copie-1`} alt={texts[44][`menu-title`]} />
        </ExploreSection>
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-9 xl:tw-col-end-8 md:tw-mt-10 md:tw-mb-10 xl:tw-mb-20`}>{texts[44].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2014`}
      date={2014}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-2 xl:tw-col-start-2 md:tw-col-end-8`}>
        <Picture
          className={`tw-relative 2xl:tw-left-20 xl:tw-left-14 md:tw-left-4 2xl:tw--mt-44 xl:tw--mt-36 lg:tw--mt-28 md:tw--mt-24`}
          filename={`FS327037_RVB_573595-copie-2`}
          alt={texts[45][`menu-title`]}
          animation={`translate-y`}
          translate={170}
          duration={1.4}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-8 xl:tw-col-start-9 md:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-36 tw-z-10 tw-mb-5 md:tw-mb-0`}>{texts[45].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`2015`}
      date={2015}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-relative tw-col-start-2 xl:tw-col-start-4 tw-col-end-13 tw-mb-5 md:tw-mb-0`}>
        <Picture className={`2xl:tw--mt-20 md:tw--mt-14`} filename={`RI-CA-CF-MA-14-02-02-1`} alt={texts[46][`menu-title`]} />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-4 xl:tw-col-start-5 md:tw-col-end-9 xl:tw-col-end-8 md:tw-mt-10 md:tw-mb-10 xl:tw-mb-20`}>{texts[46].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20`}
      anchorName={`2018`}
      date={2018}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-6 tw-row-start-1 md:tw-mt-10 xl:tw-mt-24 tw-mb-5 md:tw-mb-0`}>{texts[47].paragraph}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-7 md:tw-col-end-11`}>
        <Picture
          className={`tw-relative 2xl:right-32 xl:right-24 md:right-5 2xl:tw--mt-44 xl:tw--mt-32 md:tw--mt-24`}
          filename={`CAR_CRL1002175_CCS_01_24_TC_1797270-1`}
          alt={texts[47][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1.4}
        />
      </PictureContainer>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-24`}
      anchorName={`2019`}
      date={2019}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 xl:tw-col-start-4 md:tw-col-end-8`}>
        <Picture
          className={`tw-relative 2xl:right-5 md:right-3 2xl:tw--mt-20 xl:tw--mt-14 md:tw--mt-10`}
          filename={`CAR_CRB4229900_CCS_01_01_TC_1812460-2`}
          alt={texts[48][`menu-title`]}
          animation={`translate-y`}
          translate={160}
          duration={1}
        />
      </PictureContainer>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 md:tw-col-start-9 xl:tw-col-end-11 tw-row-start-1 md:tw-mt-10 xl:tw-mt-36 tw-mb-5 md:tw-mb-0`}>{texts[48].paragraph}</div>
    </BlockSection>,

    <BlockSection
      sectionClassName={`tw-mb-10 md:tw-mb-0 md:tw-mt-20 tw-pb-20 md:tw-pb-44`}
      anchorName={`2019-2`}
      date={2019}
      svgWrapperClassName={`tw-relative tw-z-20 tw-w-full tw-mb-5 md:tw-mb-0`}
    >
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 lg:tw-col-start-4 md:tw-col-end-7 xl:tw-col-end-6 tw-row-start-1 md:tw-mt-5 lg:tw-mt-10 xl:tw-mt-24 tw-relative md:right-4 lg:right-8 tw-mb-5 md:tw-mb-0`}>{texts[49].paragraph}</div>
      <div className={`${constants.paragraph} section-paragraph tw-col-start-2 tw-col-end-12 lg:tw-col-start-4 md:tw-col-end-7 xl:tw-col-end-6 md:tw-mt-5 lg:tw-mt-10 tw-relative md:right-4 lg:right-8 tw-mb-5 md:tw-mb-0`}>
        {texts[49]['paragraph-second']}</div>
      <PictureContainer className={`tw-col-start-2 tw-col-end-12 md:tw-col-start-7 xl:tw-col-start-6 xl:tw-col-end-11 2xl:tw--mt-0 md:tw--mt-4`}>
        <Picture
          className={`tw-relative 2xl:tw-left-6 xl:tw-left-4 2xl:tw--mt-60 xl:tw--mt-64 md:tw--mt-52`}
          filename={`Cartier_poster_NACT_2041209-1`}
          alt={texts[49][`menu-title`]}
          animation={`mask-left`}
          duration={1}
        />
      </PictureContainer>
    </BlockSection>,

    <Footer />,

  ]
  const Row = () => (sectionsItems.map((item, index) => <div key={`1${index}2`}>{item}</div>))
  return (
    <div ref={appTemplateEl} id={`app-template`} className={`tw-w-full tw-h-full`} style={{ fontSize: `100%` }}>
      <div ref={listWrapperEl} className={`tw-relative tw-z-10`}>
        <Row />
      </div>
      <Menu className={`tw-hidden lg:tw-block tw-relative tw-z-10`} />
      <MenuMobile className={`tw-block lg:tw-hidden tw-relative tw-z-10`} />
    </div>
  )
}

export default App
